/** Customer-facing display + card tip configuration (synced from dashboard). */
export const MAX_BANNER_IMAGE_URLS = 4;
export const LOYALTY_SIGNUP_DEFAULTS = {
    headline: 'Join our rewards',
    subtext: 'Scan with your phone & earn points every visit',
    ctaLabel: 'Join rewards',
    scanHint: 'Open your camera and point at the code',
    benefits: ['Free to join', 'Earn on every visit', 'Member discounts'],
};
export const LOYALTY_SIGNUP_QR_TIMEOUT_SECONDS = 60;
export const DEFAULT_CUSTOMER_DISPLAY = {
    enabled: false,
    bannerTitle: '',
    bannerMessage: 'Welcome!',
    bannerImageUrls: [],
    tipEnabled: true,
    tipPreset1Pct: 5,
    tipPreset2Pct: 10,
    tipPreset3Pct: 15,
    tipSmallOrderThresholdAmd: 2000,
    tipSmallPreset1Amd: 100,
    tipSmallPreset2Amd: 200,
    tipSmallPreset3Amd: 500,
    tipTimeoutSeconds: 60,
    tipDepartmentId: null,
    tipAdgCode: null,
    tipProductCode: 'TIP',
    tipProductName: 'Tip',
    loyaltySignupEnabled: false,
    loyaltySignupUrl: '',
    loyaltySignupHeadline: LOYALTY_SIGNUP_DEFAULTS.headline,
    loyaltySignupSubtext: LOYALTY_SIGNUP_DEFAULTS.subtext,
    loyaltySignupCtaLabel: LOYALTY_SIGNUP_DEFAULTS.ctaLabel,
};
/** Normalize banner URLs from array + legacy single-URL column. */
export function normalizeBannerImageUrls(urls, legacySingleUrl) {
    const normalized = (Array.isArray(urls) ? urls : [])
        .map((u) => String(u).trim())
        .filter(Boolean)
        .slice(0, MAX_BANNER_IMAGE_URLS);
    if (normalized.length > 0)
        return normalized;
    const legacy = legacySingleUrl?.trim();
    return legacy ? [legacy] : [];
}
/** Returns true when card checkout can print a tip line on the HDM. */
export function isTipFiscalConfigured(s) {
    return s.tipDepartmentId != null && !!s.tipAdgCode?.trim();
}
/** Marketing copy for loyalty signup screen (falls back to defaults). */
export function resolveLoyaltySignupCopy(settings) {
    return {
        headline: settings.loyaltySignupHeadline.trim() || LOYALTY_SIGNUP_DEFAULTS.headline,
        subtext: settings.loyaltySignupSubtext.trim() || LOYALTY_SIGNUP_DEFAULTS.subtext,
        ctaLabel: settings.loyaltySignupCtaLabel.trim() || LOYALTY_SIGNUP_DEFAULTS.ctaLabel,
        scanHint: LOYALTY_SIGNUP_DEFAULTS.scanHint,
        benefits: [...LOYALTY_SIGNUP_DEFAULTS.benefits],
    };
}
/** True when idle-screen loyalty CTA + QR should appear. */
export function isLoyaltySignupPromoActive(settings) {
    return settings.loyaltySignupEnabled && !!settings.loyaltySignupUrl.trim();
}
//# sourceMappingURL=customer-display.js.map